module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("K")])])])]), _vm._v("athryn stood at the top of the cliff, looking down at the sea as it swirled about the rocks far below her. The wind tore at her hair, catching at her cloak, buffeting her from all sides as she stared out to the far horizon, her thoughts returning as always when she came here to that day in her childhood—the day when the bravery of her companion had saved her life. Never would she forget how they had gone down to the cove in direct disobedience to their fathers’ commands; how their curiosity about the strange ship in the bay had brought disaster.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Kathryn’s cheeks were wet as she wiped the tears with the back of her hand. There was no point in weeping. Dickon had gone from her, from his family, taken by the Corsairs who had come ashore to find water and food. It seemed that some of the villagers had been trading with these evil men who plagued the seas of the Mediterranean and occasionally ventured as far as the coasts of England and Cornwall. How often she had regretted that she had not been more mindful of her duty, for it was she who had prompted her companion to go down and investigate the strange ship.")])])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shivering, Kathryn recalled the way the fierce pirates had suddenly swooped on them as they walked innocently towards where the pirates were plying their trade with the rogue villager. That man had long disappeared from the village, for when Kathryn escaped from the clutches of the men who had tried to seize her, he must have known she would tell her story. But her beloved Dickon had not escaped. He had pushed her behind him, telling her to run for help while he had bravely fought against the men who attacked them. At the top of the cliff, she had stopped, turning to see that they were carrying Dickon on board the boat that had brought them ashore, and that he appeared to be unconscious.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Kathryn had run as fast as she could to her father’s house, spilling out her tale of abduction and treachery, but when the party of men had arrived at the beach it was to find it empty, with no sign of the brave lad who had fought against impossible odds. He was but fifteen when they took him, but Kathryn knew he would have been sold as a slave, perhaps to work in the kitchens of some eastern potentate. Or perhaps, because he was tall and strong for his age, he had been chained to an oar in one of the raiders’ galleys.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had wept bitter tears, for she had loved Dickon. He was her friend and her soulmate and, though their families lived some leagues distant from one another, they had known each other well. Kathryn believed that it was the intention of both fathers that they should marry one day, when she was nineteen. She was almost nineteen now and soon her father would make arrangements for her to marry someone else. But in her heart she belonged to Richard Mountfitchet—her own Dickon.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("‘Dickon…’ Kathryn whispered, her words whipped ")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("away by the wind, drowned by the cries of seabirds and the crashing of the waves against the rocky Cornish coastline. ‘Forgive me. I never thought it would happen. I did not know that such evil men existed until that day. I miss you. I still love you. I shall always love you.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("It was ten years to the day, Kathryn thought, and every year she came here at the same time hoping to see Dickon, praying that he might return to her and his family. Yet she knew it was impossible. How could he return? Their fathers had sent men to search the slave markets in Algiers. They had contacted friends in Cyprus, Venice and Constantinople, the city that the Turks now called Istanbul, but which was still known in the Christian world by its old name. Always, there was unrest between the Turks and the Christians; wars, quarrels, and differences of religion and culture made it difficult to conduct a search within the Ottoman Empire. For Sultan Selim II was constantly seeking to push out the boundaries of his empire and had boasted that one day he would stand victorious in Rome itself. However, there were a few men who could help and one of them was Suleiman Bakhar.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Suleiman had an English wife. He was a clever, educated man and travelled tirelessly, trading, trying to reach out to the world beyond the Ottoman Empire, and hoping to bring about peace, though there was such hatred, such a history of conflict between their peoples that it seemed the breach could not be bridged.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Kathryn knew that Suleiman Bakhar was in England at this time. He had promised to make inquiries on behalf of Lord Mountfitchet, but as far as she knew he had discovered nothing that could help them. Sir John Rowlands and Lord Mountfitchet had gone to London to speak with him, for they had other business of which Kathryn knew ")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("nothing, and it would suit them to meet with Suleiman at the same time. But they were expected to return today, and Kathryn felt a flicker of hope as she turned her steps towards the beautiful old manor house that was her home. It had once been fortified against attack from the sea, but, in these more peaceful times of Queen Elizabeth’s reign, it had become simply a family home rather than a fortress, with many improvements to make it more comfortable.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("As she reached her home, she saw that a cumbersome travelling coach had pulled up in the courtyard and she began to run, her heart racing. Perhaps this time there would be news of Dickon…")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("Lorenzo Santorini stood on the steps of his palace. It was built at the edges of the Grand Canal, the huge lagoon that wound through the city and beneath the many bridges of Venice. The city had established trading arrangements with the Muslim world that had helped it to become one of the most powerful seagoing nations on earth a hundred years earlier. It was from here that the great Marco Polo had set out on his voyage of expedition that had taken him as far as the court of Kublai Khan, opening up the known world far beyond what it had been previously. However, the Turkish invasions and the unrest of recent years had led to gradual erosion of the Republic’s supremacy.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("The Venetian galleys were, however, still thought to be some of the best craft available and remained a force to be reckoned with; the merchants of Venice were rich and influential—and Lorenzo Santorini was one of the most powerful amongst them. His galleys were famed for their speed, fighting abilities and the discipline of his men, none of whom were slaves.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("He frowned as he saw the galley making its way towards ")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("the small jetty where he stood waiting. It was one of the fleet that he owned which guarded his merchant ships, and it was late returning from what should have been a routine trip to Cyprus to buy wine. As it drew closer, he could see that it had taken part in some fighting—which could only mean that it had been attacked by a Turkish or Corsair galley.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘Welcome back, Michael,’ Lorenzo said as the captain mounted the steps towards him. He extended his hand, helping him jump up to the steps of the palace. ‘I thought there must have been some trouble—was it Rachid again?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘Is it not always Rachid?’ Michael dei Ignacio replied with a grimace. ‘He hates us and will harry our vessels whenever he gets the chance. Fortunately, I had left Cyprus in company with three other galleys and the ship that carried your wine. We lost one of our fighting galleys, but the merchant ship is safe. It is but an hour behind me, accompanied by two galleys. We came ahead because we have several injured men on board.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘They must be tended by the physicians,’ Lorenzo said with a frown, ‘and all shall be compensated for the hurt they have suffered.’ In Lorenzo’s galleys the men were paid for their work, not chained to their oars the way the wretched prisoners were in the galleys of those men most feared in these waters. The Corsairs, or Barbary pirates, as some were wont to call them, roamed the seas from the Mediterranean and Adriatic to the Barbary Coast and the Atlantic. They were fearsome men who were a law unto themselves, owing no allegiance to anyone, though some paid tribute to the Ottoman Empire.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘It shall be attended to,’ Michael promised. Lorenzo was a good master to work for, and a mystery to most, for few knew anything of his history. Michael himself knew that Lorenzo was the adopted son of the man whose name ")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("he bore; of much of what had gone before he was as ignorant as the next man.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("‘I know I can leave their welfare in your hands,’ Lorenzo said. His eyes were the colour of violets, a dark blue and as unreadable as his thoughts. His hair, the colour of sun-ripened corn bleached white at the tips, was worn longer than the fashion of the time; thick and strong, it curled in his neck. ‘I leave for Rome in the morning. I have been summoned to a meeting concerning these pirates.’ His lip curled in scorn, for he included the Turks, who had caused the merchants of Venice so much trouble these past fifty years or so and now had the audacity to demand Cyprus of the Doge, something that would be fiercely resisted by the Venetians. ‘As you know, there is talk of gathering a force to curb Selim’s power, otherwise he will sweep further into Europe. The Emperor is concerned and he hopes to bring in Spain as well as other allies to break the power of the Turks.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Michael nodded, for he knew that his friend was considered an important man by certain men of influence in the Holy Roman Empire. Lorenzo owned twenty fighting galleys besides his fleet of four merchant ships, and he would certainly be asked to join any force that attempted to sweep the menace of the Turkish invaders from the seas. There was a widely held belief that, could they but break the power of the Ottoman Empire, many of the Corsairs would lose much of their own power.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("‘They need to be curbed,’ Michael agreed. ‘In the meantime, we have captured one of Rachid’s oarsmen. We sank one of his galleys and this man was brought out of the water, still chained to the wooden spar that prevented him from drowning. We shall see what information we can persuade him to give us about his master’s stronghold—’")])])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I will not have him tortured,’ Lorenzo said. ‘No matter that he is a Turk and an enemy, he shall be treated as a man. If he is willing to help us, we shall offer him employment in our ranks. If he refuses to co-operate, we will see if he can be ransomed to his family.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lorenzo rubbed at one of the wide leather bands he habitually wore on his wrists, his eyes as dark as the deepest waters of the Mediterranean and as impenetrable.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I do not believe he is of Turkish origin,’ Michael said. ‘He will not answer when spoken to, though he understands the language of his masters, also some French and, I think, English.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lorenzo looked at him in silence for a moment. ‘This man is not to be ill treated,’ he said. ‘You will leave his questioning to me when I return, if you please, my friend. And now you must rest, enjoy the benefits of home and family for a few days. You have earned them. When I return from Rome we shall meet again.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘As you command,’ Michael said, watching as his friend signalled to a small gondola that was waiting to ferry him out to his personal galley, which was further out in the lagoon. He was curious as to why his commander had suddenly decided that he wanted to interrogate the prisoner himself, but he would obey his orders. The reason Michael, born of good family, had chosen to sail with Lorenzo Santorini was because he respected him; he was a fair man, not cruel—though he would not suffer disobedience lightly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Lorenzo was thoughtful as he boarded the galley, which was the flagship of his fleet, the fastest and newest of the vessels he owned, with the benefit of three sails, to be used when the wind was fair, thus giving the oarsmen a chance to rest. Such galleys were still much faster and easier to ")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("manoeuvre than the top-heavy galleons the Spanish favoured. Even the smaller, lighter craft of the English merchant adventurers, who had begun to be a considerable force in these seas, would find it difficult to keep pace with this galley. Turkish galleys seldom attacked his ships—they knew that he was a man to be reckoned with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("His real quarrel, however, was with Rachid the Feared One, a man of such cruelty that his name was well earned. The pitiful creatures that served at the oar in his fleet were wretched indeed, few surviving more than three years of beatings and torture.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Lorenzo’s eyes darkened as he remembered one such object of pity, a man who had survived by chance. He would never rest until Rachid was brought to justice, either at the end of a rope or by the sword. He had vowed it at the deathbed of the man who had adopted him, and one day he would keep his promise.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("He regretted that he had lost one of his galleys in this struggle, for men must have died, though their comrades would have saved all they could. Rachid had also lost men and galleys, but for him life was cheap. He would replenish his oarsmen from the slave markets of Algiers or simply send a raiding party to one of the islands of the Aegean to capture men, women and children. The men would serve in his galleys, the women and children would be sold as house slaves—a trade that revolted all good Christian men and women.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("It would be interesting to hear what plans were afoot in Rome, for he would welcome any fight that lead to the demise of such men. Rachid paid tribute to the Sultan of the Ottoman Empire and was free to pillage and murder as he would in these waters. If the power of the Turks could be curbed, it would make his enemy that much more vulnerable.")])])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But even if he had to enter his very stronghold to do it, one day he would find and kill the man he hated.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘It is so good to see you, sir.’ Kathryn kissed the cheek of their visitor. Lord Mountfitchet was almost as dear to her as her own father, and she looked forward to his visits. They had been rare enough since Dickon was stolen all those years ago. ‘Did you see the man of whom Father told me—Suleiman Bakhar?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yes, we spoke with him at length,’ Lord Mountfitchet told her with a sigh. ‘But there is no news. He has made inquiries for us, for, as you must know, his influence is far reaching in that part of the world. However, he has not given up hope—though he says that it would be rare for a man to survive that long in the galleys. It depends what happened to Richard when he was taken. If he was sold as a house slave…he could be anywhere.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘We must pray that he was,’ Kathryn’s father said, shaking his head over the sad business. ‘Otherwise…’ He looked sorrowful. For his own part he believed that Richard Mountfitchet must be long dead, but his friend had refused to give up his search and he did not blame him. If it had been his own son or—God forbid—Kathryn, he might have felt the same.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I do not believe that Dickon is dead,’ Kathryn said. ‘I am sure that I would have felt it in here.’ She pressed her clenched hands to her breast as if in prayer. ‘You "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("must")])]), _vm._v(" go on searching for him, sir.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘Yes, Kathryn.’ Lord Mountfitchet smiled at her. She was lovely with her dark red hair and green eyes, a sweetness about her mouth that was testament to her tender nature, but more than that she had helped him to retain the hope of his son being restored to him one day. ‘That is why ")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("I have come to stay with you for a while. It is in my mind to visit Venice and Cyprus. As you know, I have recently begun to import wine from Cyprus and Italy to this country. I began to take an interest in the region when I started my search for Richard, and I am thinking that I might decide to live out there in the future.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘You would leave England?’ Kathryn stared at him in surprise; she had heard nothing of this before now. ‘But what of your estate?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘The house and land could be left to my agents to administer. It might be that I shall want to return one day, but there is little for me here now. In Elizabeth’s England, Catholics like myself and your father are not given an equal chance. I mean no disrespect to the Queen, for I know she must take the advice of her ministers—and they live in fear of a Catholic plot against her. I have taken no part in such plots nor would I, for she is our rightful Queen, but there is nothing to keep me here. If our poor Dickon lives, he must be somewhere in that region of the world—perhaps Algiers, or Constantinople.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘We shall miss you,’ Kathryn said and her throat caught with tears at the thought that she might never see him again. ‘How shall we know if there is news of Dickon?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘I should write to you, of course,’ he said and smiled at her. ‘But if I live there I shall need a good friend in this country to keep an eye on my affairs. I have asked Sir John if he would join me in this venture of importing wines, and he has been good enough to agree.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Kathryn looked at her father, who confirmed his satisfaction with the arrangement. ‘Then at least we shall hear from you sometimes.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Lord Mountfitchet nodded, looking at her thoughtfully. ‘Your father is too busy to accompany me on this voyage ")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("of exploration, Kathryn, but I would like him to have firsthand knowledge of what I intend to do there. He has suggested to me that you might accompany my party. My sister, Lady Mary Rivers, was widowed a few months past and has agreed to make the journey with me, for she has nothing to keep her here either and we shall be company for each other in our dotage.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘You are not yet in your dotage, sir!’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘No, you are right—but it comes to us all in time, Kathryn. Mary and I get on well enough, and I have no wish to marry again. She thinks me a fool to search for Dickon, but keeps a still tongue on the subject. She will be your chaperon on the journey, and I believe we shall find a suitable guardian to accompany you on the return journey—unless you meet someone that you would wish to marry.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘Oh…’ Kathryn looked at her father, a faint colour in her cheeks.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘I had it in mind to look about for a suitable husband for you, daughter,’ her father said, and paused. ‘But Lord Mountfitchet is right. There is little opportunity for Catholics in this country these days. If you should chance to meet someone suitable who you liked while on your travels, I should be pleased. I know that Mary and Charles would take care of you and make sure that any suitor was worthy of you before advising me. Indeed, I shall probably make the journey to fetch you home myself. If I were not so busy at the moment, I would come with you. Your brother Philip will be home from Oxford next year and, if I cannot come myself, he will be happy to take my place, for he longs to travel.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘Yes, I know.’ Kathryn gave him a look of affection, for she was fond of her brother. ‘Would you truly not mind if I went with Lord Mountfitchet and Lady Mary?’")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I should miss you, Kathryn,’ her father said, his eyes warm with affection. ‘Had your mother lived I might have been able to introduce you to a gentleman you could like before this. I have been too busy to see to it, and, besides, I think you need a woman to help you make such a decision. When Lady Mary told me she was to accompany Charles I thought it an opportunity for you to see a little of the world. I fear you must have been too often lonely since your dear mother left us.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Kathryn smiled, but it was true enough. She had her good friends, neighbours and the elderly nurse who had been almost as a mother to her, but she had missed the time she had spent with her mother, talking and working at her sewing. It was nine years since the fever had taken her, just a year or so after Dickon was abducted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Where do you intend to go first, sir?’ she asked, turning her clear green eyes on Lord Mountfitchet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘We should return to London and my sister,’ he replied. ‘Then we should travel to Dover, and from thence to Venice. I have made contact with a merchant there, a rich, powerful man from whom I have been buying fine wines these past three years. It is he who has encouraged me to expand my business. I shall consult with him before I make my final choice, though I believe Cyprus will suit me rather than Italy itself. I have it in my mind to establish a vineyard there.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘May I think about this for a little and give you my answer in the morning?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yes, of course. I know it is a grave decision—it would mean that you would be away from your home for many months.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("‘I believe I know my answer, but I would think about it,’ Kathryn said and smiled at him. ‘If you will excuse me ")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("now, sir, I shall leave you both, for I have things to attend to.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Until the morning, my dear.’ Lord Mountfitchet bowed to her as she walked away.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘She is a good girl,’ Sir John Rowlands said as the door closed behind her and sighed regretfully. ‘Her feelings for Dickon went deep and she has never forgotten him. I think they made some childish pact between them, but she has not told me the details. Until she accepts that all hope of Dickon is gone, I believe she will resist the idea of marriage with another.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘It would be a shame if she were to waste her life,’ Lord Mountfitchet said. ‘Much as I hope that we shall find some news of him in Venice, I would not have Kathryn grieve for my son for ever. She is young and beautiful of face as well as nature, and she deserves some happiness.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Do you think this merchant of whom you spoke may have news?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘I pray it may be so. Suleiman Bakhar knows him well. He told me that Lorenzo Santorini has helped several slaves who have managed to escape from their masters. He sometimes buys them in the slave markets of Algiers or takes prisoners from the pirate galleys he sinks, and he will ransom a Corsair captain for galley slaves. I think he exchanged ten slaves for one such man just a few months back. He gives them the chance to work for him, and sometimes he will return them to their families. He might ask for a ransom for his trouble, but for myself I would gladly pay it.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘He sounds a man to be reckoned with?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Indeed, he is. Suleiman admires him—they have a mutual respect, I believe, though Santorini hath no love for Corsairs or the Turks. Indeed, I have heard that he hates them.’")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yet Suleiman Bakhar calls him friend.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Suleiman is a man of enlightenment, as you know. He has only one wife, Eleanor, though his religion allows him to have several, and he adores her. They travel together and though she adopts Muslim dress when in his country, she wears English garb in ours. Suleiman says that if anyone can find Dickon, it is Santorini.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sir John nodded. ‘And that is the true reason you want Kathryn to accompany you, isn’t it? You believe that Dickon will need both you and her if he is found.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘What will he be like if he has survived?’ Lord Mountfitchet said, his face grey with grief. The abduction of his son had haunted him these many years, giving him no peace. ‘He is bound to have suffered terribly. He will need nursing and care if we are to teach him how to live again.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yes, I fear you are right,’ Sir John agreed. ‘Perhaps Kathryn is the only one who might help him. They were so close as children.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I have not told her my thoughts on this matter,’ Charles Mountfitchet said. ‘It would make her feel that she ought to accompany us—but I would have her come only if she wishes it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yes, it must be as she wishes,’ Sir John said. ‘I would not have it otherwise. Yet if she should want to marry…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I shall write to you at once,’ his friend promised. ‘But Mary will have a care to her. We shall not allow some ruthless fortune hunter to snare her.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Her fortune is adequate, but not huge,’ Sir John said. ‘I have my son to think of and, as you said, Catholics are not given the chance to rise these days. Philip will not be given a post at court as I was when Mary was Queen.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("‘That is why you do well to join me in my venture,’ ")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Lord Mountfitchet said. ‘We may trade where we will, for the world is bigger than this country of ours.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("‘Yes, I believe you are right,’ Sir John said, ‘though for myself I would be loath to leave it as you intend.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("‘Perhaps I might have thought as you if…’ Lord Mountfitchet sighed and shook his head. ‘It does no good to repine. If Santorini can give me no hope, then I may accept that I shall never see my son again.’")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Kathryn looked at herself in her small hand mirror. It had come all the way from Venice and had once belonged to her mother. She touched the smooth silver handle with her fingertips. The merchants of Venice were known for the quality of their wares, and it was from that city that the beautiful glass posset set, which her mother had treasured, had come.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("It would be a great adventure to go with Lady Mary and Lord Mountfitchet. She had never expected to leave the shores of her homeland, for her father was not a great traveller. Yet she had read the histories in his library, those rare and valuable books and bound manuscripts that she was privileged to share, and her mind was open to new things. And of course Venice was renowned as a centre of publishing, particularly of the poets and of great histories. She thought that she would like to see new countries, new places—and there was always the possibility that they might discover something concerning Dickon’s whereabouts.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Her hair was hanging loose about her shoulders, a dark, shining red mass of waves that gleamed with fire when it caught the candlelight. She got up and went over to the window, gazing out into the darkness. She could see very little for there were no stars to light the sky that night. Her ")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("father had spoken of her finding someone she might wish to marry—but how could she ever do that when her heart belonged to Dickon? She had given him her promise as a girl and he had taken his knife and cut her initial into the back of his wrist. She had cried out in alarm, for it had bled a lot, and had given him a lace kerchief to bind it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("‘Does it hurt very much?’ she had asked and he had laughed, his eyes bold and daring.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("‘It is nothing, for I know that this blood binds you to me for ever.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("She had kissed the wound then, tasting his blood, and had known that she would always love him. She would resist any attempts to marry her to a man she did not love. She would behave modestly when travelling and listen to Lady Mary’s advice, but she would not let them marry her to a man she did not respect or feel some affection for. Perhaps one day she would feel inside her that Dickon was dead. If that happened, she might consider marriage. If not…")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Her thoughts seemed to come up against a blank wall, for she did not know what she would do if Dickon never returned to her. There was no alternative to marriage for a woman of her class, unless she wished to retire to a convent. Women married or became nuns, unless their male relatives had a use for them. Perhaps Philip would accept her as a dependent in his household if she grew old and past the age of being a wife.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("It was a sad prospect, but what else was there for her? Laying down her mirror, Kathryn went to her bed, which was a heavy box base with four posts and a carved tester overhead. A handsome thing, it was piled high with soft mattresses filled with goose feathers, for the slats were wooden and hard. Slipping beneath the luxury of silken quilts, she wondered what life was like on board ship.")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yet she would put up with any discomfort if, at the end of the journey, she could find the man she loved.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The momentum was gathering, Lorenzo thought as he left the meeting to which he had been summoned. There had been talk of forming an alliance to fight a campaign against the Turks for a long time, but now, at last, it looked as though it might actually happen later that year. Pope Pius V had formed the Holy League with Spain and Venice, and it was hoped that others would bring their ships to help fight the menace that had haunted the Mediterranean seas and the Messina Strait for so long. Many had thought the talking would simply go on and on, and negotiations would probably continue for a while. However, after these latest threats against Cyprus and Rome itself, it seemed that His Holiness was determined to strike against the enemy that had for so long threatened the nations of Christendom.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Leaving the palace, Lorenzo was thoughtful as he walked, his mind dwelling not on the conference that he had attended, but on a letter that had reached him shortly before he left Venice. It was from an Englishman with whom he had done business in the past, telling him that he was coming to Venice and asking if he could help to trace a youth who had been abducted from the shores of his homeland over ten years previously.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lorenzo frowned, for it was a thankless task. He knew as well as any man how unlikely it was that the youth had survived.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("He would, of course, do what he could to help Lord Mountfitchet, for although they had never met he had heard good things of the gentleman. His father, Antonio Santorini, had visited England some years previously and had spoken ")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("of meeting Lord Mountfitchet, saying that he was both honest and decent. Therefore, Lorenzo would help him, but to trace a man who had been taken by Corsairs so long ago…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Lorenzo’s instincts remained alert even while his mind wrestled with his problems, and he was aware that he was being followed. So when the attack was made, he was ready for it, drawing his sword as he turned to meet the three ruffians who rushed upon him out of the darkness.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("‘Come, my friends,’ he invited with a cold smile that only served to intensify the ice of his eyes. ‘Would you have my purse? Come, take it if you can…’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("One of the three, bolder than the others, took him at his word. They clashed swords, contesting the fight fiercely, but the rogue was no match for a master swordsman and called for help from his comrades. The other two came at Lorenzo warily, for they had seen that he was no easy mark. Outnumbered three to one, he held his own for some minutes, slashing to left and right as each one attacked in turn, whirling out of reach, retreating, then advancing as he fought with the skill and ferocity his years as master of a war galley had brought him. Even so, the odds were against him and it might have gone ill with him in the end had not a newcomer joined in the fray, bringing his own skill and courage to Lorenzo’s assistance.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Lorenzo’s sword found its mark, disabling one of the three. Finding that the odds were now even and that they were being driven back, the other two rogues broke and ran, whilst the wounded fellow leaned against a wall, clutching his arm, blood oozing through his fingers.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Lorenzo had sheathed his sword when the others ran, but the stranger who had come to his aid still held his, regarding the would-be assassin speculatively.")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Shall we kill him?’ he asked of Lorenzo. ‘’Tis what the dog deserves—or do you wish to question him?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘His purpose was to rob me,’ Lorenzo answered with a careless shrug. ‘Let him go to join his companions—unless he would prefer a quick death?’ His hand moved to his sword hilt suggestively.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The man gave a squeak of fear, suddenly finding the strength to run in the wake of his comrades. A harsh laugh escaped the stranger, who turned to Lorenzo.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You are merciful, sir. I think he would have killed you if he could.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I do not doubt it.’ Lorenzo smiled. ‘I thank you for your help, sir. I am—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I know you, Signor Santorini,’ the stranger said before he could continue. ‘I am Pablo Dominicus and you were pointed out to me at the conference we both attended. I followed you because I wish to speak with you.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Then good fortune followed me this night,’ Lorenzo said. ‘Shall we find an inn where we can sit and talk, if you have some business you would discuss?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘My business is twofold,’ Pablo Dominicus said. ‘I am on the one hand an emissary from His Holiness the Pope—and on the other I am a man seeking revenge. I believe we have a common enemy.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘Indeed?’ Lorenzo’s eyes narrowed. It seemed the stranger was a Spaniard. He had no great love of the Spanish, for the Inquisition was a fearful thing, practised by many in the name of Catholicism, but stronger and more powerful in Spain than most countries. And it was known that Spain resented Venice for its independence, and considered that some of its inhabitants would benefit from the attention of the Inquisition. There were men who served in Lorenzo’s galleys who had known what it was ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("to suffer torture and beatings at the hands of the fanatics who ruled the religious order. Yet there was only polite inquiry in Lorenzo’s voice as he said, ‘Pray tell me more, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("señor")])]), _vm._v(". I would know how I may serve you?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘Let us find somewhere we can be private, Signor Santorini. I have a request from His Holiness, for your name is well known to him—and another of my own.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘There is an inn I know in the next street,’ Lorenzo said. ‘If your business is secret we can take a private chamber and be sure that we are not overheard.’")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Lorenzo drank sparingly of the rich red wine Dominicus had ordered, listening to the request being made of him. In the darkness of the streets he had been unable to see the face of Don Pablo clearly, but now he saw that he was a man in his middle years. Heavily built, he wore a small, dark pointed beard, his hair short and thinning at the temples. And there was a faint unease in his manner that Lorenzo found interesting.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘His Holiness requests that you pledge your support to our cause,’ Don Pablo said. ‘Your galleys are some of the finest and your men are strong and brave, and, I am told, loyal to you. If you join us in the League, others will surely follow.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘It was my intention to make my offer once I had consulted with my captains,’ Lorenzo said, his eyes thoughtful as he studied the other man. Why was it that he did not quite believe him as honest as he appeared? ‘I shall join your cause for it is also mine, but the men who serve me are free to choose. I believe most will follow me, for they have cause to hate the Turks and their allies.’ Some hated the Spanish just as much, but he would not say that. ‘Now, perhaps you would care to tell me the true reason you chose to follow me this evening?’")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Don Pablo smiled. ‘They told me you were clever. I shall not insult your intelligence by holding to the claim that I am here on the Pope’s behalf, for that might have been left to others, though I know His Holiness intends to approach you. I followed you because I believe you have good cause to hate Rachid—he they call the Feared One. I have heard it said that you hate him and would see him dead if it were possible.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lorenzo was silent for a moment, then, ‘What has Rachid done to you?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Three months ago his galleys attacked and captured one of my merchant ships,’ Don Pablo said and his fist clenched on the table. It was clear that he was suffering some deep emotion. ‘That cost me a great deal of money—and one of the men he killed was my son-in-law.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I am sorry for your loss, sir.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘My daughter and grandchildren are living in Cyprus,’ Don Pablo went on and his hand shook as if he were in the grip of some strong emotion. ‘Immacula wants to return to Spain with her children. I would send ships to fetch her myself—but I have suffered other losses of late. Those accursed English privateers, as they call themselves, have been harrying my ships as they return from the New World…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You are asking me to bring your daughter to you?’ Lorenzo’s brows arched as he studied the other’s face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I am willing to pay for your time, of course.’ Don Pablo’s eyes dropped before Lorenzo’s intense gaze.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘My galleys are meant for war. They are not suitable for a woman and children. I think you must look elsewhere for your escort, Señor Dominicus.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You mistake me, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("signor")])]), _vm._v(". Immacula will naturally travel in our own ship. I but ask for an escort to see her safely to Spain.’")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You want my galleys to escort your ship?’ Lorenzo nodded, his gaze narrowing as he studied the Spaniard. Something was not right about this. His instincts were telling him to be wary, and they were seldom wrong. ‘My men work for me. They are not for hire to others.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Surely they would do as you bid them?’ Don Pablo’s eyes were dark with suppressed anger and something more—was it fear? Lorenzo could not decide, but sensed that there was more to this than he had been told. ‘I believed you commanded. Do not tell me that those who serve you dictate what you do, for I should not believe it!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lorenzo’s mouth curved in a strange, cold smile that sent a shiver down the spine of his companion. ‘Forgive me if I speak plainly, Don Pablo. Some of my men have suffered at the hands of the Spanish Inquisition. They would spit in your face rather than fight for you.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Don Pablo’s face suffused with anger, his neck a dark red colour. He started to his feet as if he would strike out in anger. ‘You refuse me? I had heard that you were a man of business. Surely my gold is as good as the next man’s?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘For myself I would take your money,’ Lorenzo said, his face a stone mask that revealed nothing of his thoughts, ‘but I cannot expect my men to fight for a Spaniard.’ He stood up and inclined his head. ‘I am sorry, but I believe you may find others willing to assist you.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You may name your own price.’ Don Pablo flung the words after him, seeming desperate. ‘I beg you to help me, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("signor")])]), _vm._v(".’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘My answer remains the same, Don Pablo.’ Lorenzo turned to look at him, his eyes cold and resolute. He was certain now that his instincts had been right; this was not a simple matter of business. ‘When you decide to tell me the truth, I may reconsider, sir—but until then, farewell.’")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A look of fear mixed with horror came to the Spaniard’s eyes and for a moment he seemed as if he would speak, but he shook his head and in another moment Lorenzo closed the door behind him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His instincts had served him well as always. He believed that the attack on him had been planned, not random, a ploy to make him grateful to Dominicus—to make him accept the commission that was offered in a sense of friendship and trust. Lorenzo had learned in a hard school that few men were to be trusted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There was more behind this than met the eye, and it smelled wrong. If his enemies had set a trap, it would need to be baited more cleverly than this.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ba7d58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ransombride_ch01.vue
// module id = 114
// module chunks = 0